export default function BrowserFrame({ src, alt, url, className = "" }) {
    return (
        <div
            className={`overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_24px_60px_-24px_rgba(15,23,42,0.25)] ${className}`}
        >
            <div className="flex items-center gap-3 border-b border-slate-100 bg-slate-50 px-4 py-2.5">
                <span className="flex gap-1.5">
                    <span className="h-2.5 w-2.5 rounded-full bg-rose-400" />
                    <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
                    <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
                </span>
                <span className="rounded-full bg-white px-4 py-1 text-[11px] font-medium text-slate-500 border border-slate-200">
                    {url}
                </span>
            </div>
            <img src={src} alt={alt} className="block w-full" loading="lazy" />
        </div>
    );
}
